import {IDataColumn} from '..';

export class DataColumn<ValueType = any> {
    public colId: string;
    public value: ValueType;
    public hidden: boolean;
    public colspan: number;
    public shifted?: boolean;
    public hasNegativeValue?: boolean;
    public hasIcon?: boolean;
    public isClickable?: boolean;
    public hasInfoIcon?: boolean;
    public class?: string;

    constructor(data: IDataColumn<ValueType>) {
        this.colId = data.colId;
        this.value = data.value;
        this.hidden = data.hidden;
        this.colspan = !data.colspan ? 1 : data.colspan;
        this.shifted = !!data.shifted;
        this.hasNegativeValue = !!data.hasNegativeValue;
        this.hasIcon = !!data.hasIcon;
        this.isClickable = !!data.isClickable;
        this.hasInfoIcon = !!data.hasInfoIcon;
        this.class = data.class ?? null;
    }
}
